module.exports = __webpack_public_path__ + "media/images/df-magazine-spring-23-8e813723.jpeg";